import { useState } from "react";
import { apiPost } from "../api/api";

export default function ChangePassword() {
  const [oldp, setOldp] = useState("");
  const [newp, setNewp] = useState("");
  const [msg, setMsg] = useState("");

  async function submit(e) {
    e.preventDefault();
    try {
      const res = await apiPost("/users/change-password", {
        old_password: oldp,
        new_password: newp,
      });

      setMsg(res.msg || "Password alterada!");
      setOldp("");
      setNewp("");
    } catch (err) {
      setMsg("Erro");
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Alterar Password</h2>
      <form onSubmit={submit}>
        <input
          type="password"
          placeholder="Password atual"
          value={oldp}
          onChange={(e) => setOldp(e.target.value)}
        /><br /><br />
        <input
          type="password"
          placeholder="Nova password"
          value={newp}
          onChange={(e) => setNewp(e.target.value)}
        /><br /><br />
        <button type="submit">Alterar</button>
      </form>
      {msg && <p>{msg}</p>}
    </div>
  );
}
